export const goToExternalLink = (e, link: string, newWindow: boolean) => {
    e.preventDefault()
    if (newWindow) {
        window.open(link, '_blank')
    } else {
        window.location.href = link
    }
}

export const reloadSamePage = (e) => {
    e.preventDefault()
    window.location.reload()
}

export const reloadSamePageWithoutEvent = () => {
    window.location.reload()
}
